import { cipher as ForgeCipher, hmac as ForgeHmac, random as ForgeRandom, util as ForgeUtil } from 'node-forge';
import { CRYPTO_KEY_LENGTH } from '#block-store/types';
import { concatRawBuffers } from '#common/util';
export const createAesCrypto = () => {
    return new NodeForgeAesCrypto();
};
class NodeForgeAesCrypto {
    static ALGORITHM = 'AES-GCM';
    seqId = 0n;
    encrypt(unencrypted, cryptoKey, iv) {
        if (!iv || iv.length === 0) {
            iv = this.generateIv();
        }
        const aesKey = ForgeUtil.createBuffer(cryptoKey, 'raw');
        const ivBuffer = ForgeUtil.createBuffer(iv, 'raw');
        const cipher = ForgeCipher.createCipher(NodeForgeAesCrypto.ALGORITHM, aesKey);
        cipher.start({ iv: ivBuffer });
        cipher.update(ForgeUtil.createBuffer(unencrypted));
        const isSuccess = cipher.finish();
        if (!isSuccess) {
            throw new Error('Error occurred while encrypting!');
        }
        const resData = NodeForgeAesCrypto.decodeBytes(cipher.output.getBytes());
        return { value: resData, iv };
    }
    decrypt(encrypted, cryptoKey, tag = '') {
        const aesKey = ForgeUtil.createBuffer(cryptoKey, 'raw');
        const tagBuffer = ForgeUtil.createBuffer(tag, 'raw');
        const aesIv = ForgeUtil.createBuffer(encrypted.iv, 'raw');
        const decipher = ForgeCipher.createDecipher(NodeForgeAesCrypto.ALGORITHM, aesKey);
        const buf = ForgeUtil.createBuffer(encrypted.value);
        decipher.start({ iv: aesIv, tagLength: tag.length * 8, tag: tagBuffer });
        decipher.update(buf);
        const isSuccess = decipher.finish();
        if (!isSuccess) {
            throw new Error('Decryption error!');
        }
        return NodeForgeAesCrypto.decodeBytes(decipher.output.getBytes());
    }
    generateKey() {
        return NodeForgeAesCrypto.decodeBytes(ForgeRandom.getBytesSync(CRYPTO_KEY_LENGTH));
    }
    getHmac(text, key) {
        const aesKey = ForgeUtil.createBuffer(key, 'raw');
        const buf = ForgeUtil.createBuffer(text, 'raw');
        const hmac = ForgeHmac.create();
        hmac.start('sha1', aesKey);
        hmac.update(buf.bytes());
        const result = NodeForgeAesCrypto.decodeBytes(hmac.digest().getBytes());
        return result;
    }
    generateIv() {
        this.seqId = this.seqId + 1n;
        const seqId = new Uint8Array(BigInt64Array.from([this.seqId]).buffer);
        const randomBytes = NodeForgeAesCrypto.decodeBytes(ForgeRandom.getBytesSync(4));
        return concatRawBuffers([randomBytes, seqId]);
    }
    static decodeBytes(bytes) {
        return ForgeUtil.binary.raw.decode(bytes);
    }
}
